/**
 * A section of a page headed by the question it answers, with one line under the heading
 * saying what the numbers are and where they come from. The History and Forecast pages
 * are built from these so someone who did not build the app can read either page top to
 * bottom without being told what each block is.
 */
export function Section({ title, caption, children }: { title: string; caption: string; children: React.ReactNode }) {
  return (
    <section className="mb-6">
      <h2 className="text-[14px] font-bold">{title}</h2>
      <p className="mb-2 max-w-3xl text-[12px] text-ink-3">{caption}</p>
      {children}
    </section>
  );
}
